module.exports = __webpack_public_path__ + "img/617e43e1b6a8d78c9928cf21_logotype.78023df0.svg";